import { ConnectivityEvaluator } from '@shape-construction/utils/network/ConnectivityEvaluator';
import { onlineManager } from '@tanstack/react-query';

export const connectivity = new ConnectivityEvaluator({
  pingUrl: '/alive',
  isOnline: () => navigator.onLine,
});

export const initializeConnectivityEvaluator = () => {
  void connectivity.start();
  connectivity.subscribe((isOnline) => {
    onlineManager.setOnline(isOnline);
  });
};
